import { useRef } from "react";
import { useDownloadExcel } from "react-export-table-to-excel";
import { capitalizeEachWord } from "../helper-functions/CapitalizeName";
import "../styles/excelexport.css"

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function ExcelExport({ cards, boardName }: any) {
    const tableRef = useRef(null);

    const { onDownload } = useDownloadExcel({
        currentTableRef: tableRef.current,
        filename: boardName ? boardName.trim() : "Board Details",
        sheet: boardName ? boardName.trim() : "Board"
    });

    return (
        <>
            {
                cards &&
                <div>
                    <button className="btn btn-sm btn-info p-2 mx-3 export_btn text-nowrap" onClick={onDownload}> Export to Excel </button>
                    <table ref={tableRef} hidden>
                        <tbody>
                            <tr>
                                <th>Card ID</th>
                                <th>Title</th>
                                <th>Description</th>
                                <th>Due Date</th>
                                <th>Status</th>
                                <th>Priority</th>
                                <th>Assignees</th>
                            </tr>
                            {
                                cards?.map((item: any) =>

                                    <tr key={item.id}>
                                        <td>{item?.key?.trim()}</td>
                                        <td>{item.card_name}</td>
                                        <td>{item.description && item.description.replace(/<[^>]+>/g, '')}</td>
                                        <td>{item.due_date}</td>
                                        <td>{item.status === "todo" ? "To Do" : item.status === "done" ? "Done" : "In Progress"}</td>
                                        <td>{item.priority}</td>
                                        <td>{item.assignees ? capitalizeEachWord(item.assignees.toString()) : capitalizeEachWord(item.assignees)}</td>
                                    </tr>
                                )
                            }

                        </tbody>
                    </table>
                </div>
            }
        </>
    );
}
